import React from 'react';

export default () => (
  <div className="progress loader">
    <div className="indeterminate" />
  </div>
);